import React, { createContext, useState, useContext, useEffect } from 'react'

// 创建认证上下文
const AuthContext = createContext({
  user: null,
  isAuthenticated: false,
  setAuthState: () => {},
})

/**
 * 认证状态提供者
 * 从 qiankun 全局状态接收认证信息并提供给子组件
 */
export function AuthProvider({ children, initialState = {}, qiankunProps = {} }) {
  const [authState, setAuthState] = useState({
    user: initialState.user || null,
    isAuthenticated: initialState.isAuthenticated || false,
  })

  // 设置 qiankun 全局状态监听
  useEffect(() => {
    console.log('[React AuthContext] 组件已挂载，设置状态监听')

    if (qiankunProps.onGlobalStateChange) {
      // 监听全局状态变化（第二个参数 true 表示立即执行一次获取当前状态）
      const unsubscribe = qiankunProps.onGlobalStateChange((state, prev) => {
        console.log('[React AuthContext] 接收到全局状态变化:', state)
        
        // 确保 isAuthenticated 有默认值
        setAuthState({
          user: state.user || null,
          isAuthenticated: state.isAuthenticated === true, // 显式转换为 boolean
        })
      }, true)

      console.log('[React AuthContext] 状态监听已设置')

      // 清理函数
      return () => {
        if (unsubscribe && typeof unsubscribe === 'function') {
          unsubscribe()
        }
      }
    } else {
      console.log('[React AuthContext] 独立运行模式，无 qiankun props')
    }
  }, [qiankunProps])

  useEffect(() => {
    console.log('[React 子应用] 认证状态更新:', authState)
  }, [authState])

  return (
    <AuthContext.Provider value={{ ...authState, setAuthState }}>
      {children}
    </AuthContext.Provider>
  )
}

/**
 * 使用认证状态的 Hook
 */
export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth 必须在 AuthProvider 内部使用')
  }
  return context
}

export default AuthContext
